module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_0.bbd0897a.png";